import React, { useEffect } from "react";
import ContactForm from "../../../components/Landing/ContactForm";

const Contact = () => {
  useEffect(() => {
    document.title = "Snilnk - Contact";
  }, []);
  return (
    <>
      <ContactForm />
    </>
  );
};

export default Contact;
